import * as React from "react";
export const NotificationIcon = (props) => (
    <svg
    width={34}
    height={33}
    viewBox="0 0 34 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_ii_220_91)">
      <rect
        x="1.86682"
        y="1.18652"
        width="30.2782"
        height="30.2782"
        rx="15.1391"
        fill="#1767D0"
      />
    </g>
    <rect
      x="1.36682"
      y="0.686523"
      width="31.2782"
      height="31.2782"
      rx="15.6391"
      stroke="white"
    />
    <rect
      x="4.95648"
      y="4.27588"
      width="24.099"
      height="24.099"
      rx="12.0495"
      fill="white"
    />
    <g clipPath="url(#clip0_220_91)">
      <path
        d="M23.4435 19.55C22.4057 18.6728 21.8107 17.3906 21.8107 16.0323V14.1187C21.8107 11.7034 20.0165 9.704 17.6925 9.36905V8.62778C17.6925 8.24821 17.385 7.94141 17.0061 7.94141C16.6272 7.94141 16.3197 8.24821 16.3197 8.62778V9.36905C13.995 9.704 12.2015 11.7034 12.2015 14.1187V16.0323C12.2015 17.3906 11.6064 18.6728 10.5625 19.5555C10.2955 19.784 10.1424 20.1162 10.1424 20.4676C10.1424 21.13 10.6812 21.6688 11.3435 21.6688H22.6686C23.331 21.6688 23.8698 21.13 23.8698 20.4676C23.8698 20.1162 23.7167 19.784 23.4435 19.55Z"
        fill="#1767D0"
      />
      <path
        d="M17.0061 24.4141C18.2491 24.4141 19.2889 23.528 19.5278 22.355H14.4844C14.7232 23.528 15.7631 24.4141 17.0061 24.4141Z"
        fill="#1767D0"
      />
    </g>
    <defs>
      <filter
        id="filter0_ii_220_91"
        x="0.866821"
        y="-0.813477"
        width="32.2782"
        height="34.2783"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius={1}
          operator="erode"
          in="SourceAlpha"
          result="effect1_innerShadow_220_91"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation="0.55" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0235294 0 0 0 0 0.407843 0 0 0 0 0.823529 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_220_91" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={-1} />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.45098 0 0 0 0 0.607843 0 0 0 0 0.917647 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_220_91"
          result="effect2_innerShadow_220_91"
        />
      </filter>
      <clipPath id="clip0_220_91">
        <rect
          width="16.4729"
          height="16.4729"
          fill="white"
          transform="translate(8.76965 7.94141)"
        />
      </clipPath>
    </defs>
  </svg>
  
);

export const SettingIcon = (props) => (
    <svg
    width={34}
    height={33}
    viewBox="0 0 34 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_ii_220_82)">
      <rect
        x="1.79507"
        y="1.18652"
        width="30.2782"
        height="30.2782"
        rx="15.1391"
        fill="#1767D0"
      />
    </g>
    <rect
      x="1.29507"
      y="0.686523"
      width="31.2782"
      height="31.2782"
      rx="15.6391"
      stroke="white"
    />
    <rect
      x="4.8847"
      y="4.27588"
      width="24.099"
      height="24.099"
      rx="12.0495"
      fill="white"
    />
    <g clipPath="url(#clip0_220_82)">
      <path
        d="M24.8159 18.1631L23.2746 16.9579C23.2942 16.772 23.3109 16.5547 23.3109 16.3249C23.3109 16.095 23.2949 15.8777 23.2746 15.6919L24.8173 14.486C25.1038 14.2596 25.182 13.8578 24.9997 13.5232L23.3969 10.7501C23.2257 10.4371 22.8505 10.2764 22.4697 10.4168L20.6511 11.1469C20.3024 10.8954 19.937 10.683 19.559 10.5132L19.2824 8.5842C19.2369 8.21808 18.9183 7.94141 18.5418 7.94141H15.3279C14.9513 7.94141 14.6334 8.21808 14.5886 8.5786L14.3113 10.5147C13.9452 10.6796 13.5854 10.8892 13.2213 11.1483L11.3978 10.4161C11.0561 10.2841 10.6474 10.4322 10.4776 10.7438L8.87275 13.5204C8.68342 13.8404 8.76166 14.2561 9.05442 14.4881L10.5957 15.6933C10.5712 15.9287 10.5594 16.1334 10.5594 16.3256C10.5594 16.5177 10.5713 16.7224 10.5957 16.9586L9.05301 18.1645C8.76654 18.3916 8.68899 18.7933 8.87134 19.1273L10.4741 21.9003C10.6453 22.2126 11.017 22.3747 11.4013 22.2336L13.2199 21.5035C13.5679 21.7543 13.9333 21.9667 14.3113 22.1372L14.588 24.0655C14.6333 24.433 14.9513 24.7097 15.3285 24.7097H18.5425C18.9191 24.7097 19.2377 24.433 19.2824 24.0725L19.5597 22.1372C19.9258 21.9716 20.285 21.7627 20.6497 21.5028L22.4732 22.235C22.5613 22.2692 22.6528 22.2867 22.7471 22.2867C23.0182 22.2867 23.2676 22.1386 23.3934 21.908L25.0031 19.1203C25.182 18.7933 25.1037 18.3916 24.8159 18.1631ZM16.9348 19.1203C15.3935 19.1203 14.1401 17.8668 14.1401 16.3256C14.1401 14.7843 15.3935 13.5309 16.9348 13.5309C18.4761 13.5309 19.7295 14.7843 19.7295 16.3256C19.7295 17.8668 18.4761 19.1203 16.9348 19.1203Z"
        fill="#1767D0"
      />
    </g>
    <defs>
      <filter
        id="filter0_ii_220_82"
        x="0.795074"
        y="-0.813477"
        width="32.2782"
        height="34.2783"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius={1}
          operator="erode"
          in="SourceAlpha"
          result="effect1_innerShadow_220_82"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation="0.55" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0235294 0 0 0 0 0.407843 0 0 0 0 0.823529 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_220_82" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={-1} />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.45098 0 0 0 0 0.607843 0 0 0 0 0.917647 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_220_82"
          result="effect2_innerShadow_220_82"
        />
      </filter>
      <clipPath id="clip0_220_82">
        <rect
          width="16.7683"
          height="16.7683"
          fill="white"
          transform="translate(8.55002 7.94141)"
        />
      </clipPath>
    </defs>
  </svg>
  
);
export const InfoIcon = (props) => (
    <svg
  width={34}
  height={33}
  viewBox="0 0 36 36"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g filter="url(#filter0_ii_205_26481)">
    <rect
      x="1.15442"
      y="1.31836"
      width="33.5107"
      height="33.5107"
      rx="16.7554"
      fill="#1767D0"
    />
  </g>
  <rect
    x="0.654419"
    y="0.818359"
    width="34.5107"
    height="34.5107"
    rx="17.2554"
    stroke="white"
  />
  <rect
    x="4.57397"
    y="4.7373"
    width="26.6718"
    height="26.6718"
    rx="13.3359"
    fill="white"
  />
  <path
    d="M19.305 15.9552L15.87 16.3857L15.747 16.9557L16.422 17.0802C16.863 17.1852 16.95 17.3442 16.854 17.7837L15.747 22.9857C15.456 24.3312 15.9045 24.9642 16.959 24.9642C17.7765 24.9642 18.726 24.5862 19.1565 24.0672L19.2885 23.4432C18.9885 23.7072 18.5505 23.8122 18.2595 23.8122C17.847 23.8122 17.697 23.5227 17.8035 23.0127L19.305 15.9552ZM19.41 12.8232C19.41 13.2211 19.2519 13.6026 18.9706 13.8839C18.6893 14.1652 18.3078 14.3232 17.91 14.3232C17.5121 14.3232 17.1306 14.1652 16.8493 13.8839C16.568 13.6026 16.41 13.2211 16.41 12.8232C16.41 12.4254 16.568 12.0439 16.8493 11.7626C17.1306 11.4813 17.5121 11.3232 17.91 11.3232C18.3078 11.3232 18.6893 11.4813 18.9706 11.7626C19.2519 12.0439 19.41 12.4254 19.41 12.8232Z"
    fill="url(#paint0_linear_205_26481)"
  />
  <defs>
    <filter
      id="filter0_ii_205_26481"
      x="0.154419"
      y="-0.681641"
      width="35.5107"
      height="37.5107"
      filterUnits="userSpaceOnUse"
      colorInterpolationFilters="sRGB"
    >
      <feFlood floodOpacity={0} result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feMorphology
        radius={1}
        operator="erode"
        in="SourceAlpha"
        result="effect1_innerShadow_205_26481"
      />
      <feOffset dy={1} />
      <feGaussianBlur stdDeviation="0.55" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.0235294 0 0 0 0 0.407843 0 0 0 0 0.823529 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="shape"
        result="effect1_innerShadow_205_26481"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy={-1} />
      <feGaussianBlur stdDeviation={1} />
      <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.45098 0 0 0 0 0.607843 0 0 0 0 0.917647 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="effect1_innerShadow_205_26481"
        result="effect2_innerShadow_205_26481"
      />
    </filter>
    <linearGradient
      id="paint0_linear_205_26481"
      x1="17.535"
      y1="11.3232"
      x2="17.535"
      y2="24.9642"
      gradientUnits="userSpaceOnUse"
    >
      <stop stopColor="#1767D0" />
      <stop offset={1} stopColor="#1767D0" />
    </linearGradient>
  </defs>
</svg>

  
);
export const PlusIcon = (props) => (
    <svg
    width={27}
    height={28}
    viewBox="0 0 27 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_220_78)">
      <rect
        x="0.685669"
        y="0.467773"
        width="25.716"
        height="25.716"
        rx="12.858"
        fill="url(#paint0_linear_220_78)"
      />
    </g>
    <path
      d="M18.7718 11.5831H15.2864V8.0977C15.2864 7.6355 15.1028 7.19224 14.7759 6.86541C14.4491 6.53859 14.0058 6.35498 13.5436 6.35498C13.0814 6.35498 12.6382 6.53859 12.3114 6.86541C11.9845 7.19224 11.8009 7.6355 11.8009 8.0977L11.8628 11.5831H8.31548C7.85328 11.5831 7.41001 11.7668 7.08319 12.0936C6.75636 12.4204 6.57275 12.8637 6.57275 13.3259C6.57275 13.7881 6.75636 14.2313 7.08319 14.5582C7.41001 14.885 7.85328 15.0686 8.31548 15.0686L11.8628 15.0067L11.8009 18.554C11.8009 19.0162 11.9845 19.4595 12.3114 19.7863C12.6382 20.1132 13.0814 20.2968 13.5436 20.2968C14.0058 20.2968 14.4491 20.1132 14.7759 19.7863C15.1028 19.4595 15.2864 19.0162 15.2864 18.554V15.0067L18.7718 15.0686C19.234 15.0686 19.6773 14.885 20.0041 14.5582C20.3309 14.2313 20.5145 13.7881 20.5145 13.3259C20.5145 12.8637 20.3309 12.4204 20.0041 12.0936C19.6773 11.7668 19.234 11.5831 18.7718 11.5831Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_220_78"
        x="0.685669"
        y="0.467773"
        width="25.716"
        height="26.7158"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_220_78"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_220_78"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_220_78"
        x1="13.5437"
        y1="0.467773"
        x2="13.5437"
        y2="26.1838"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#039B00" />
        <stop offset={1} stopColor="#00E25B" />
      </linearGradient>
    </defs>
  </svg>
  
);

export const RupeeIcon = (props) => (
    <svg width={28} height={29} viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_ii_112_107)">
            <rect x="1.28223" y="1.4697" width="25.716" height="25.716" rx="12.858" fill="#684C00" />
        </g>
        <rect x="0.782227" y="0.969696" width="26.716" height="26.716" rx="13.358" stroke="#AD8E08" />
        <g clipPath="url(#clip0_112_107)">
            <path
                d="M23.5081 13.9494C23.5081 19.2851 19.1827 23.6106 13.847 23.6106C11.0343 23.6106 8.50226 22.4086 6.73684 20.4902C6.27311 19.9867 5.86261 19.4334 5.51323 18.8399C4.66976 17.4054 4.18591 15.7338 4.18591 13.9494C4.18591 8.61375 8.51133 4.28833 13.847 4.28833C15.6318 4.28833 17.3033 4.77217 18.7375 5.61604C19.331 5.96503 19.8838 6.37553 20.3874 6.83965C22.3058 8.60429 23.5081 11.1367 23.5081 13.9494Z"
                fill="#F0CD00"
            />
            <path
                d="M23.5081 13.9495C23.5081 19.1649 19.3759 23.415 14.2066 23.6039C9.03735 23.415 4.90515 19.1649 4.90515 13.9495C4.90515 8.73403 9.03735 4.48393 14.2066 4.29504C19.3759 4.48393 23.5081 8.73403 23.5081 13.9495Z"
                fill="#FFDE50"
            />
            <path d="M20.3874 6.83967L6.73679 20.4902C6.27306 19.9867 5.86256 19.4334 5.51318 18.84L18.7375 5.61606C19.3309 5.96504 19.8838 6.37554 20.3874 6.83967Z" fill="#FFEA94" />
            <path d="M22.8417 10.4174L10.3146 22.9445C9.42772 22.5959 8.60475 22.12 7.86853 21.5391L21.4367 7.97098C22.0175 8.70719 22.4935 9.53016 22.8417 10.4174Z" fill="#FFEA94" />
            <path
                d="M21.3543 13.9494C21.3543 18.0954 17.993 21.4567 13.847 21.4567C12.403 21.4567 11.0543 21.049 9.9096 20.3423C9.41077 20.0348 8.95098 19.67 8.53851 19.2575C8.23527 18.9547 7.95766 18.6254 7.70963 18.2741C7.36814 17.7902 7.08225 17.2642 6.86182 16.7054C6.53531 15.8793 6.35155 14.981 6.34051 14.0417C6.33972 14.011 6.33972 13.9802 6.33972 13.9494C6.33972 9.80345 9.70061 6.44217 13.847 6.44217C13.8778 6.44217 13.9089 6.44217 13.9397 6.44296C14.879 6.454 15.7769 6.63815 16.603 6.96426C17.1618 7.18509 17.6878 7.47059 18.1716 7.81208C18.523 8.06051 18.8519 8.33772 19.1551 8.64096C19.5676 9.05304 19.9323 9.51322 20.2399 10.0121C20.9465 11.1568 21.3543 12.5054 21.3543 13.9494Z"
                fill="#FAA300"
            />
            <path
                d="M19.1551 8.64096L8.53851 19.2575C8.23527 18.9547 7.95766 18.6254 7.70963 18.2741C7.36814 17.7902 7.08225 17.2642 6.86182 16.7054C6.53531 15.8793 6.35155 14.981 6.34051 14.0417C6.33972 14.011 6.33972 13.9802 6.33972 13.9495C6.33972 9.80345 9.70061 6.44217 13.847 6.44217C13.8778 6.44217 13.9089 6.44217 13.9397 6.44296C14.879 6.454 15.7769 6.63815 16.603 6.96426C17.1618 7.18509 17.6878 7.47059 18.1716 7.81208C18.523 8.06051 18.8519 8.33772 19.1551 8.64096Z"
                fill="#FFBD00"
            />
            <path
                d="M21.3542 13.9494C21.3542 18.0954 17.9929 21.4567 13.8469 21.4567C13.7045 21.4567 13.5634 21.4528 13.423 21.4449C17.3718 21.2253 20.506 17.9531 20.506 13.9494C20.506 9.9458 17.3718 6.67364 13.423 6.454C13.5634 6.44611 13.7045 6.44217 13.8469 6.44217C17.9929 6.44217 21.3542 9.80345 21.3542 13.9494Z"
                fill="#F68E00"
            />
            <path
                d="M16.8296 11.6505H15.5149C15.44 11.357 15.3238 11.0799 15.1738 10.8251H16.8296C17.2651 10.8251 17.6182 10.472 17.6182 10.0365C17.6182 9.60089 17.2651 9.2478 16.8296 9.2478H12.4224H9.37851C8.94293 9.2478 8.58984 9.60089 8.58984 10.0365C8.58984 10.472 8.94293 10.8251 9.37851 10.8251H12.4224C13.026 10.8251 13.553 11.1585 13.8298 11.6505H9.37851C8.94293 11.6505 8.58984 12.0036 8.58984 12.4392C8.58984 12.8747 8.94293 13.2278 9.37851 13.2278H13.8298C13.553 13.7199 13.026 14.0532 12.4224 14.0532H9.37855C9.06383 14.0532 8.77924 14.2403 8.65451 14.5292C8.52975 14.8181 8.58874 15.1536 8.80452 15.3827L13.0936 19.9352C13.2488 20.1 13.4581 20.1831 13.6678 20.1831C13.8618 20.1831 14.0561 20.1119 14.2085 19.9685C14.5255 19.6698 14.5403 19.1706 14.2417 18.8536L11.205 15.6305H12.4224C13.9099 15.6305 15.1629 14.6073 15.5149 13.2278H16.8296C17.2651 13.2278 17.6182 12.8747 17.6182 12.4392C17.6182 12.0036 17.2651 11.6505 16.8296 11.6505Z"
                fill="#F68E00"
            />
            <path
                d="M17.8154 11.6505H16.5007C16.4258 11.357 16.3096 11.0799 16.1596 10.8251H17.8154C18.2509 10.8251 18.604 10.472 18.604 10.0365C18.604 9.60089 18.2509 9.2478 17.8154 9.2478H13.4082H10.3643C9.92877 9.2478 9.57568 9.60089 9.57568 10.0365C9.57568 10.472 9.92877 10.8251 10.3643 10.8251H13.4082C14.0118 10.8251 14.5388 11.1585 14.8156 11.6505H10.3643C9.92877 11.6505 9.57568 12.0036 9.57568 12.4392C9.57568 12.8747 9.92877 13.2278 10.3643 13.2278H14.8156C14.5388 13.7199 14.0118 14.0532 13.4082 14.0532H10.3644C10.0497 14.0532 9.76508 14.2403 9.64035 14.5292C9.51559 14.8181 9.57458 15.1536 9.79036 15.3827L14.0795 19.9352C14.2346 20.1 14.4439 20.1831 14.6536 20.1831C14.8476 20.1831 15.042 20.1119 15.1943 19.9685C15.5114 19.6698 15.5262 19.1706 15.2275 18.8536L12.191 15.6305H13.4083C14.8958 15.6305 16.1488 14.6073 16.5008 13.2278H17.8155C18.2511 13.2278 18.6041 12.8747 18.6041 12.4392C18.6041 12.0036 18.2509 11.6505 17.8154 11.6505Z"
                fill="#FFEA94"
            />
        </g>
        <defs>
            <filter id="filter0_ii_112_107" x="0.282227" y="-0.530304" width="27.7161" height="29.716" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dy={1} />
                <feGaussianBlur stdDeviation="0.55" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
                <feColorMatrix type="matrix" values="0 0 0 0 0.966667 0 0 0 0 0.861978 0 0 0 0 0.61625 0 0 0 1 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_112_107" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dy={-1} />
                <feGaussianBlur stdDeviation={1} />
                <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.792781 0 0 0 0 0.483333 0 0 0 1 0" />
                <feBlend mode="normal" in2="effect1_innerShadow_112_107" result="effect2_innerShadow_112_107" />
            </filter>
            <clipPath id="clip0_112_107">
                <rect width="19.3222" height="19.3222" fill="white" transform="translate(4.18591 4.28833)" />
            </clipPath>
        </defs>
    </svg>
);

export const UserIcon = (props) => (
    <svg
    width={23}
    height={23}
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="11.6321"
      cy="11.4747"
      r="10.3121"
      fill="white"
      stroke="url(#paint0_linear_220_104)"
      strokeWidth={2}
    />
    <g clipPath="url(#clip0_220_104)">
      <path
        d="M11.5323 10.7824C12.4588 10.7824 13.2611 10.4501 13.9166 9.79452C14.5721 9.13902 14.9044 8.33697 14.9044 7.41039C14.9044 6.48412 14.5721 5.68197 13.9165 5.02626C13.2608 4.37086 12.4587 4.03857 11.5323 4.03857C10.6057 4.03857 9.80368 4.37086 9.14818 5.02636C8.49268 5.68186 8.16028 6.48401 8.16028 7.41039C8.16028 8.33697 8.49268 9.13912 9.14828 9.79462C9.80389 10.45 10.606 10.7824 11.5323 10.7824Z"
        fill="#0668D2"
      />
      <path
        d="M17.4325 14.804C17.4136 14.5312 17.3753 14.2336 17.319 13.9194C17.2622 13.6028 17.1891 13.3035 17.1015 13.03C17.011 12.7473 16.888 12.4681 16.7359 12.2005C16.578 11.9228 16.3926 11.681 16.1845 11.482C15.9669 11.2738 15.7005 11.1064 15.3925 10.9843C15.0855 10.8629 14.7453 10.8014 14.3814 10.8014C14.2385 10.8014 14.1003 10.86 13.8334 11.0338C13.6691 11.1409 13.4769 11.2648 13.2625 11.4019C13.0791 11.5187 12.8306 11.6282 12.5237 11.7273C12.2243 11.8242 11.9204 11.8733 11.6203 11.8733C11.3203 11.8733 11.0164 11.8242 10.7167 11.7273C10.4102 11.6283 10.1617 11.5188 9.97853 11.402C9.76608 11.2662 9.57382 11.1423 9.40709 11.0337C9.14049 10.8599 9.00217 10.8013 8.85925 10.8013C8.49524 10.8013 8.15515 10.8629 7.84828 10.9845C7.54045 11.1063 7.27396 11.2737 7.05617 11.4821C6.84821 11.6812 6.66267 11.9229 6.50502 12.2005C6.35303 12.4681 6.22998 12.7472 6.1394 13.0301C6.05193 13.3036 5.97876 13.6028 5.92194 13.9194C5.86565 14.2332 5.82741 14.5309 5.8085 14.8043C5.78992 15.0722 5.78052 15.3502 5.78052 15.6311C5.78052 16.3619 6.01283 16.9535 6.47095 17.3898C6.9234 17.8204 7.52208 18.0388 8.25011 18.0388H14.9912C15.7192 18.0388 16.3177 17.8205 16.7702 17.3898C17.2285 16.9538 17.4608 16.3621 17.4608 15.6309C17.4607 15.3489 17.4512 15.0706 17.4325 14.804Z"
        fill="#0668D2"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_220_104"
        x1="4.82525"
        y1="1.92999"
        x2="19.1239"
        y2="21.4434"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CDD9F7" />
        <stop offset="0.255" stopColor="#0668D2" />
        <stop offset="0.675" stopColor="#6BAFFF" />
        <stop offset={1} stopColor="#C9D5F6" />
      </linearGradient>
      <clipPath id="clip0_220_104">
        <rect
          width={14}
          height={14}
          fill="white"
          transform="translate(4.63208 4.03857)"
        />
      </clipPath>
    </defs>
  </svg>
  
);

export const Chain = (props) => (
    <svg width={10} height={36} viewBox="0 0 10 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_i_12_1114)">
            <circle cx="5.39858" cy="2.28912" r="2.19387" fill="#4F170B" />
        </g>
        <g filter="url(#filter1_i_12_1114)">
            <circle cx="5.39858" cy="33.2848" r="2.19387" fill="#4F170B" />
        </g>
        <g clipPath="url(#clip0_12_1114)">
            <path
                d="M5.47027 11.684C7.70324 11.684 9.51343 14.6133 9.51343 18.2265C9.51343 21.8397 7.70324 24.7692 5.47027 24.7692C3.2373 24.7692 1.42723 21.8399 1.42723 18.2265C1.42723 14.6131 3.23741 11.684 5.47027 11.684ZM5.27632 22.6442C6.73819 22.6442 7.92325 20.6573 7.92325 18.2063C7.92325 15.7554 6.73819 13.7684 5.27632 13.7684C3.81445 13.7684 2.62928 15.7554 2.62928 18.2063C2.62928 20.6573 3.81445 22.6438 5.27632 22.6438V22.6442Z"
                fill="url(#paint0_linear_12_1114)"
            />
            <path
                d="M5.41408 10.9668C7.90447 10.9668 9.92261 14.2331 9.92261 18.2624C9.92261 22.2916 7.90401 25.5581 5.41408 25.5581C2.92415 25.5581 0.905556 22.2918 0.905556 18.2624C0.905556 14.233 2.92404 10.9668 5.41408 10.9668ZM5.19775 23.1886C6.82741 23.1886 8.14938 20.973 8.14938 18.2399C8.14938 15.5068 6.82832 13.2913 5.19775 13.2913C3.56717 13.2913 2.24601 15.5069 2.24601 18.24C2.24601 20.9731 3.56752 23.1886 5.19775 23.1886Z"
                fill="#BA131A"
            />
            <path
                d="M5.47035 11.3253C7.84264 11.3253 9.76587 14.45 9.76587 18.3044C9.76587 22.1588 7.84264 25.2837 5.47035 25.2837C3.09805 25.2837 1.17494 22.159 1.17494 18.3044C1.17494 14.4499 3.09851 11.3253 5.47035 11.3253ZM5.26377 23.0169C6.81688 23.0169 8.0755 20.8974 8.0755 18.283C8.0755 15.6685 6.81642 13.5489 5.26377 13.5489C3.71112 13.5489 2.45204 15.6684 2.45204 18.283C2.45204 20.8976 3.71112 23.0169 5.26423 23.0169H5.26377Z"
                fill="url(#paint1_linear_12_1114)"
            />
            <path
                d="M5.47035 11.6122C7.84264 11.6122 9.76587 14.7369 9.76587 18.5915C9.76587 22.446 7.84264 25.5701 5.47035 25.5701C3.09805 25.5701 1.17494 22.4454 1.17494 18.591C1.17494 14.7366 3.09851 11.6122 5.47035 11.6122ZM5.42972 24.8818C7.48251 24.8818 9.1466 22.0719 9.1466 18.6057C9.1466 15.1396 7.48251 12.3295 5.42995 12.3295C3.37739 12.3295 1.71342 15.1394 1.71342 18.6057C1.71342 22.0721 3.37716 24.8818 5.42972 24.8818Z"
                fill="#FFF7B3"
            />
            <path d="M7.06274 14.1227C4.07818 11.8991 2.83941 15.4138 2.83941 15.4138C4.52874 10.6798 7.06274 14.1227 7.06274 14.1227Z" fill="#FFF7B3" />
            <path d="M6.30127 23.1039C2.9358 23.9904 2.59174 20.2399 2.59174 20.2399C3.07478 25.2997 6.30127 23.1039 6.30127 23.1039Z" fill="#FFF7B3" />
            <path d="M7.62598 14.2662C10.5542 19.2154 7.45704 23.0886 7.45704 23.0886C9.09003 19.0719 7.62598 14.2662 7.62598 14.2662Z" fill="url(#paint2_linear_12_1114)" />
            <path d="M2.07703 15.2704C0.78019 18.5296 2.15186 21.0803 2.15186 21.0803C1.42884 18.4352 2.07703 15.2704 2.07703 15.2704Z" fill="url(#paint3_linear_12_1114)" />
            <path
                d="M4.23665 3.14582C4.23768 2.39438 4.74839 1.78558 5.37822 1.78558C6.00804 1.78558 6.51978 2.3957 6.51978 3.14817C6.51978 3.17626 6.51897 3.2039 6.5176 3.23155V14.435C6.51897 14.4625 6.51978 14.4902 6.51978 14.5183C6.51978 14.5464 6.51897 14.574 6.5176 14.6015V14.6991H6.50968C6.43554 15.3662 5.9572 15.8809 5.37822 15.8809C4.79923 15.8809 4.32077 15.3662 4.24664 14.6991H4.23654V3.14582H4.23665Z"
                fill="#BA131A"
            />
            <path
                d="M4.31813 3.23979C4.31928 2.49776 4.80703 1.89661 5.40839 1.89661C6.00976 1.89661 6.49866 2.49952 6.49866 3.24214C6.49866 3.26978 6.49785 3.29714 6.49659 3.32434V14.3878C6.49785 14.415 6.49866 14.4424 6.49866 14.47C6.49866 14.4977 6.49785 14.525 6.49659 14.5522V14.6487H6.48902C6.41821 15.3074 5.9611 15.8156 5.40805 15.8156C4.855 15.8156 4.39812 15.3074 4.32708 14.6487H4.31744V3.23979H4.31813Z"
                fill="url(#paint4_linear_12_1114)"
            />
            <path
                d="M6.11053 2.2288C6.32457 2.4732 6.4585 2.82172 6.4585 3.20861C6.4585 3.23611 6.45769 3.26331 6.45632 3.29037V14.2912C6.45769 14.3183 6.4585 14.3456 6.4585 14.373C6.4585 14.4003 6.45769 14.4277 6.45632 14.4547V14.5508H6.44886C6.4142 14.8612 6.29423 15.1456 6.11053 15.3528V2.2288Z"
                fill="#FFF7B3"
            />
            <path
                d="M5.40869 1.89661C5.43929 1.89661 5.46932 1.89813 5.49878 1.90117V15.811C5.46906 15.814 5.43899 15.8156 5.40869 15.8156C5.24998 15.8159 5.09301 15.7732 4.94814 15.6901V2.02219C5.09299 1.93903 5.24996 1.89622 5.40869 1.89661Z"
                fill="#FBB040"
            />
            <path
                d="M4.65256 15.0624C4.56807 15.0624 4.49958 12.2364 4.49958 8.75043C4.49958 5.26445 4.56807 2.4385 4.65256 2.4385C4.73705 2.4385 4.80554 5.26445 4.80554 8.75043C4.80554 12.2364 4.73705 15.0624 4.65256 15.0624Z"
                fill="#FFF7B3"
            />
            <path
                d="M4.23665 21.9379C4.23768 21.1865 4.74839 20.5777 5.37822 20.5777C6.00804 20.5777 6.51978 21.1878 6.51978 21.9404C6.51978 21.9684 6.51897 21.9962 6.5176 22.0237V33.2272C6.51897 33.2547 6.51978 33.2825 6.51978 33.3104C6.51978 33.3383 6.51897 33.3661 6.5176 33.3936V33.4913H6.50968C6.43554 34.1583 5.9572 34.673 5.37822 34.673C4.79923 34.673 4.32077 34.1583 4.24664 33.4913H4.23654V21.9379H4.23665Z"
                fill="#BA131A"
            />
            <path
                d="M4.31813 22.0324C4.31928 21.2903 4.80703 20.6892 5.40839 20.6892C6.00976 20.6892 6.49866 21.2921 6.49866 22.0347C6.49866 22.0624 6.49785 22.0897 6.49659 22.1169V33.1804C6.49785 33.2076 6.49866 33.235 6.49866 33.2626C6.49866 33.2903 6.49785 33.3176 6.49659 33.3448V33.4413H6.48902C6.41821 34.0999 5.9611 34.6081 5.40805 34.6081C4.855 34.6081 4.39812 34.0999 4.32708 33.4413H4.31744V22.0324H4.31813Z"
                fill="url(#paint5_linear_12_1114)"
            />
            <path
                d="M6.11053 21.0214C6.32457 21.2658 6.4585 21.6143 6.4585 22.0012C6.4585 22.0287 6.45769 22.0559 6.45632 22.0829V33.0845C6.45769 33.1114 6.4585 33.1388 6.4585 33.1663C6.4585 33.1938 6.45769 33.221 6.45632 33.2481V33.3439H6.44886C6.41417 33.6544 6.29421 33.9388 6.11053 34.1461V21.0214Z"
                fill="#FFF7B3"
            />
            <path
                d="M5.40869 20.6892C5.43899 20.6892 5.46906 20.6908 5.49878 20.6937V34.6036C5.46906 34.6065 5.43899 34.6081 5.40869 34.6081C5.24997 34.6086 5.09299 34.5658 4.94814 34.4827V20.8148C5.09299 20.7316 5.24996 20.6888 5.40869 20.6892Z"
                fill="#FBB040"
            />
            <path
                d="M4.65256 33.8549C4.56807 33.8549 4.49958 31.029 4.49958 27.543C4.49958 24.057 4.56807 21.2311 4.65256 21.2311C4.73705 21.2311 4.80554 24.057 4.80554 27.543C4.80554 31.029 4.73705 33.8549 4.65256 33.8549Z"
                fill="#FFF7B3"
            />
        </g>
        <defs>
            <filter id="filter0_i_12_1114" x="3.20471" y="0.095253" width="4.3877" height="4.38773" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dy={1} />
                <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_12_1114" />
            </filter>
            <filter id="filter1_i_12_1114" x="3.20471" y="31.091" width="4.3877" height="4.38773" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dy={1} />
                <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_12_1114" />
            </filter>
            <linearGradient id="paint0_linear_12_1114" x1="5.47027" y1="24.7692" x2="5.47027" y2="11.684" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FBB040" />
                <stop offset={1} stopColor="#8B0304" />
            </linearGradient>
            <linearGradient id="paint1_linear_12_1114" x1="9.76587" y1="18.3044" x2="1.17494" y2="18.3044" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FBB040" />
                <stop offset={1} stopColor="#FFF200" />
            </linearGradient>
            <linearGradient id="paint2_linear_12_1114" x1="8.88495" y1="18.6774" x2="7.45704" y2="18.6774" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FBB040" />
                <stop offset={1} stopColor="#8B0304" />
            </linearGradient>
            <linearGradient id="paint3_linear_12_1114" x1="1.60605" y1="18.1753" x2="2.23713" y2="18.1753" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FBB040" />
                <stop offset={1} stopColor="#8B0304" />
            </linearGradient>
            <linearGradient id="paint4_linear_12_1114" x1="6.49935" y1="8.85601" x2="4.31813" y2="8.85601" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FBB040" />
                <stop offset={1} stopColor="#FFF200" />
            </linearGradient>
            <linearGradient id="paint5_linear_12_1114" x1="6.49935" y1="27.6487" x2="4.31813" y2="27.6487" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FBB040" />
                <stop offset={1} stopColor="#FFF200" />
            </linearGradient>
            <clipPath id="clip0_12_1114">
                <rect width="9.01693" height="32.8878" fill="white" transform="matrix(-1 0 0 1 9.92261 1.78558)" />
            </clipPath>
        </defs>
    </svg>
);

export const HomeIcon = (props) => (
    <svg width={63} height={63} viewBox="0 0 63 63" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_112_103)">
            <rect x="0.765137" y="0.329834" width="61.4275" height="57.3053" rx={15} fill="#FFB600" />
        </g>
        <g clipPath="url(#clip0_112_103)">
            <path
                d="M31.5164 20.4077L21.2532 29.8162C21.2532 29.8295 21.2502 29.8491 21.2442 29.8757C21.2384 29.9021 21.2352 29.9213 21.2352 29.9349V39.4621C21.2352 39.806 21.3483 40.1041 21.5745 40.3552C21.8005 40.6064 22.0682 40.7327 22.3776 40.7327H29.2315V33.1108H33.8014V40.733H40.6552C40.9645 40.733 41.2326 40.6069 41.4584 40.3552C41.6845 40.1044 41.798 39.8061 41.798 39.4621V29.9349C41.798 29.8821 41.7915 29.8422 41.78 29.8162L31.5164 20.4077Z"
                fill="black"
            />
            <path
                d="M45.7063 27.6725L41.7975 24.0601V15.9619C41.7975 15.7768 41.744 15.6245 41.6366 15.5053C41.5301 15.3863 41.3932 15.3268 41.2263 15.3268H37.7993C37.6326 15.3268 37.4958 15.3863 37.3886 15.5053C37.2816 15.6245 37.2281 15.7768 37.2281 15.9619V19.8323L32.873 15.7831C32.4926 15.439 32.0404 15.267 31.5167 15.267C30.9931 15.267 30.5409 15.439 30.1602 15.7831L17.3262 27.6725C17.2072 27.7782 17.142 27.9204 17.1298 28.0991C17.1178 28.2776 17.1594 28.4336 17.2547 28.5658L18.3613 30.0346C18.4567 30.1536 18.5815 30.2264 18.7362 30.253C18.879 30.2664 19.0219 30.2199 19.1647 30.1141L31.5163 18.6612L43.8681 30.1141C43.9635 30.2064 44.0882 30.2525 44.2429 30.2525H44.2966C44.451 30.2263 44.5756 30.1531 44.6714 30.0343L45.7782 28.5657C45.8733 28.4332 45.915 28.2776 45.9027 28.0988C45.8905 27.9206 45.825 27.7784 45.7063 27.6725Z"
                fill="black"
            />
        </g>
        <defs>
            <filter id="filter0_d_112_103" x="0.765137" y="0.329834" width="61.4275" height="62.3052" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dy={5} />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0.858824 0 0 0 0 0.470588 0 0 0 0 0.00784314 0 0 0 1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_112_103" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_112_103" result="shape" />
            </filter>
            <clipPath id="clip0_112_103">
                <rect width="28.777" height={32} fill="white" transform="translate(17.1278 12)" />
            </clipPath>
        </defs>
    </svg>
);
export const HeaderBackIcon = (props) => (
    <svg width={68} height={78} viewBox="0 0 68 78" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_dd_12_14208)">
            <circle cx="33.7828" cy="37.5381" r="23.5026" fill="url(#paint0_linear_12_14208)" />
            <circle cx="33.7828" cy="37.5381" r="23.0026" stroke="url(#paint1_linear_12_14208)" />
        </g>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.4652 26.9952C29.9772 27.5073 29.9772 28.3375 29.4652 28.8496L25.1474 33.1673L29.4652 37.485C29.9772 37.9971 29.9772 38.8274 29.4652 39.3395C28.9531 39.8515 28.1229 39.8515 27.6108 39.3395L22.3659 34.0945C21.8538 33.5825 21.8538 32.7522 22.3659 32.2401L27.6108 26.9952C28.1229 26.4831 28.9531 26.4831 29.4652 26.9952Z"
            fill="black"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.9818 33.1673C21.9818 32.4432 22.5689 31.8561 23.293 31.8561H38.1537C40.1243 31.8561 42.0142 32.6389 43.4077 34.0324C44.8012 35.4259 45.584 37.3158 45.584 39.2864C45.584 41.257 44.8012 43.1469 43.4077 44.5404C42.0142 45.9339 40.1243 46.7167 38.1537 46.7167H28.538C27.8138 46.7167 27.2268 46.1297 27.2268 45.4055C27.2268 44.6814 27.8138 44.0943 28.538 44.0943H38.1537C39.4288 44.0943 40.6517 43.5877 41.5534 42.6861C42.455 41.7844 42.9616 40.5615 42.9616 39.2864C42.9616 38.0113 42.455 36.7884 41.5534 35.8867C40.6517 34.9851 39.4288 34.4785 38.1537 34.4785H23.293C22.5689 34.4785 21.9818 33.8915 21.9818 33.1673Z"
            fill="black"
        />
        <defs>
            <filter id="filter0_dd_12_14208" x="0.280273" y="0.035553" width="67.0051" height="77.0051" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feMorphology radius={3} operator="dilate" in="SourceAlpha" result="effect1_dropShadow_12_14208" />
                <feOffset dy={-4} />
                <feGaussianBlur stdDeviation="3.5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.73375 0 0 0 0 0.3625 0 0 0 1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_12_14208" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dy={6} />
                <feGaussianBlur stdDeviation={5} />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                <feBlend mode="normal" in2="effect1_dropShadow_12_14208" result="effect2_dropShadow_12_14208" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_12_14208" result="shape" />
            </filter>
            <linearGradient id="paint0_linear_12_14208" x1="33.7828" y1="14.0356" x2="33.7828" y2="61.0407" gradientUnits="userSpaceOnUse">
                <stop stopColor="#F9DD3E" />
                <stop offset={1} stopColor="#CD6118" />
            </linearGradient>
            <linearGradient id="paint1_linear_12_14208" x1="33.7828" y1="14.0356" x2="33.7828" y2="61.0407" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FFE897" />
                <stop offset={1} stopColor="#E2952F" />
            </linearGradient>
        </defs>
    </svg>
);

export const EditIcon = (props) => (
    <svg
    width={34}
    height={33}
    viewBox="0 0 37 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_ii_267_2)">
      <rect
        x="1.50635"
        y="1.31836"
        width="33.5107"
        height="33.5107"
        rx="16.7554"
        fill="#1767D0"
      />
    </g>
    <rect
      x="1.00635"
      y="0.818359"
      width="34.5107"
      height="34.5107"
      rx="17.2554"
      stroke="white"
    />
    <rect
      x="4.92586"
      y="4.7373"
      width="26.6718"
      height="26.6718"
      rx="13.3359"
      fill="white"
    />
    <g clipPath="url(#clip0_267_2)">
      <path
        d="M20.0158 13.1191L11.8057 21.3298C11.7644 21.3712 11.7346 21.4235 11.7204 21.4798L10.8104 25.1323C10.7831 25.2423 10.8155 25.3592 10.8957 25.4395C10.9564 25.5002 11.0391 25.5338 11.1238 25.5338C11.1497 25.5338 11.1762 25.5306 11.202 25.5241L14.8546 24.614C14.9115 24.5998 14.9632 24.5701 15.0045 24.5288L23.2153 16.3187L20.0158 13.1191Z"
        fill="#1767D0"
      />
      <path
        d="M25.2493 11.9997L24.3354 11.0858C23.7246 10.475 22.66 10.4756 22.0499 11.0858L20.9304 12.2053L24.1298 15.4047L25.2493 14.2852C25.5544 13.9802 25.7225 13.5743 25.7225 13.1425C25.7225 12.7108 25.5544 12.3048 25.2493 11.9997Z"
        fill="#1767D0"
      />
    </g>
    <defs>
      <filter
        id="filter0_ii_267_2"
        x="0.506348"
        y="-0.681641"
        width="35.5107"
        height="37.5107"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius={1}
          operator="erode"
          in="SourceAlpha"
          result="effect1_innerShadow_267_2"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation="0.55" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0235294 0 0 0 0 0.407843 0 0 0 0 0.823529 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_267_2" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={-1} />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.45098 0 0 0 0 0.607843 0 0 0 0 0.917647 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_267_2"
          result="effect2_innerShadow_267_2"
        />
      </filter>
      <clipPath id="clip0_267_2">
        <rect
          width="14.9216"
          height="14.9216"
          fill="white"
          transform="translate(10.8009 10.6128)"
        />
      </clipPath>
    </defs>
  </svg>
  
);

export const EarthIcon = (props) => (
    <svg
    width={29}
    height={29}
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.28223"
      y="0.967773"
      width="26.716"
      height="26.716"
      rx="13.358"
      fill="#34388A"
      stroke="white"
    />
    <g clipPath="url(#clip0_220_63)">
      <path
        d="M24.0081 13.9477C24.0081 19.2834 19.6827 23.6089 14.347 23.6089C11.5343 23.6089 9.00226 22.4069 7.23684 20.4885C6.77311 19.985 6.36261 19.4317 6.01323 18.8382C5.16976 17.4037 4.68591 15.7321 4.68591 13.9477C4.68591 8.61204 9.01133 4.28662 14.347 4.28662C16.1318 4.28662 17.8033 4.77047 19.2375 5.61433C19.831 5.96332 20.3838 6.37382 20.8874 6.83794C22.8058 8.60258 24.0081 11.135 24.0081 13.9477Z"
        fill="#F0CD00"
      />
      <path
        d="M24.0082 13.9479C24.0082 19.1633 19.876 23.4134 14.7067 23.6023C9.53738 23.4134 5.40518 19.1633 5.40518 13.9479C5.40518 8.73245 9.53738 4.48234 14.7067 4.29346C19.876 4.48234 24.0082 8.73245 24.0082 13.9479Z"
        fill="#FFDE50"
      />
      <path
        d="M20.8874 6.83787L7.23685 20.4884C6.77312 19.9849 6.36262 19.4316 6.01324 18.8382L19.2375 5.61426C19.831 5.96324 20.3839 6.37374 20.8874 6.83787Z"
        fill="#FFEA94"
      />
      <path
        d="M23.3417 10.4157L10.8146 22.9428C9.92775 22.5942 9.10478 22.1182 8.36856 21.5374L21.9367 7.96924C22.5176 8.70545 22.9935 9.52842 23.3417 10.4157Z"
        fill="#FFEA94"
      />
      <path
        d="M21.8543 13.9477C21.8543 18.0937 18.493 21.455 14.347 21.455C12.903 21.455 11.5544 21.0473 10.4096 20.3406C9.9108 20.033 9.45101 19.6683 9.03854 19.2558C8.7353 18.953 8.45769 18.6237 8.20966 18.2723C7.86817 17.7885 7.58228 17.2625 7.36185 16.7037C7.03534 15.8776 6.85158 14.9793 6.84054 14.04C6.83975 14.0092 6.83975 13.9785 6.83975 13.9477C6.83975 9.80171 10.2006 6.44043 14.347 6.44043C14.3778 6.44043 14.4089 6.44043 14.4397 6.44122C15.379 6.45226 16.2769 6.63641 17.103 6.96252C17.6618 7.18335 18.1878 7.46885 18.6717 7.81034C19.023 8.05877 19.3519 8.33598 19.6551 8.63922C20.0676 9.0513 20.4324 9.51148 20.7399 10.0103C21.4466 11.1551 21.8543 12.5037 21.8543 13.9477Z"
        fill="#FAA300"
      />
      <path
        d="M19.6551 8.63922L9.03854 19.2558C8.7353 18.953 8.45769 18.6237 8.20966 18.2723C7.86817 17.7885 7.58228 17.2625 7.36185 16.7037C7.03534 15.8776 6.85158 14.9793 6.84054 14.04C6.83975 14.0092 6.83975 13.9785 6.83975 13.9477C6.83975 9.80171 10.2006 6.44043 14.347 6.44043C14.3778 6.44043 14.4089 6.44043 14.4397 6.44122C15.379 6.45226 16.2769 6.63641 17.103 6.96252C17.6618 7.18335 18.1878 7.46885 18.6717 7.81034C19.023 8.05877 19.3519 8.33598 19.6551 8.63922Z"
        fill="#FFBD00"
      />
      <path
        d="M21.8541 13.9477C21.8541 18.0937 18.4928 21.455 14.3468 21.455C14.2045 21.455 14.0633 21.451 13.9229 21.4432C17.8717 21.2235 21.0059 17.9514 21.0059 13.9477C21.0059 9.94406 17.8717 6.6719 13.9229 6.45226C14.0633 6.44437 14.2045 6.44043 14.3468 6.44043C18.4928 6.44043 21.8541 9.80171 21.8541 13.9477Z"
        fill="#F68E00"
      />
      <path
        d="M17.3295 11.6488H16.0149C15.94 11.3553 15.8238 11.0782 15.6738 10.8234H17.3295C17.7651 10.8234 18.1182 10.4703 18.1182 10.0348C18.1182 9.59918 17.7651 9.24609 17.3295 9.24609H12.9223H9.87848C9.4429 9.24609 9.08981 9.59918 9.08981 10.0348C9.08981 10.4703 9.4429 10.8234 9.87848 10.8234H12.9223C13.526 10.8234 14.0529 11.1567 14.3298 11.6488H9.87848C9.4429 11.6488 9.08981 12.0019 9.08981 12.4375C9.08981 12.873 9.4429 13.2261 9.87848 13.2261H14.3298C14.0529 13.7182 13.526 14.0515 12.9224 14.0515H9.87852C9.5638 14.0515 9.27921 14.2386 9.15448 14.5275C9.02972 14.8164 9.08871 15.1519 9.30449 15.3809L13.5936 19.9335C13.7488 20.0982 13.958 20.1814 14.1678 20.1814C14.3617 20.1814 14.5561 20.1102 14.7084 19.9667C15.0255 19.6681 15.0403 19.1689 14.7416 18.8519L11.705 15.6288H12.9223C14.4099 15.6288 15.6628 14.6056 16.0149 13.2261H17.3295C17.7651 13.2261 18.1182 12.873 18.1182 12.4375C18.1182 12.0019 17.7651 11.6488 17.3295 11.6488Z"
        fill="#F68E00"
      />
      <path
        d="M18.3154 11.6488H17.0007C16.9258 11.3553 16.8097 11.0782 16.6596 10.8234H18.3154C18.751 10.8234 19.104 10.4703 19.104 10.0348C19.104 9.59918 18.751 9.24609 18.3154 9.24609H13.9082H10.8644C10.4288 9.24609 10.0757 9.59918 10.0757 10.0348C10.0757 10.4703 10.4288 10.8234 10.8644 10.8234H13.9082C14.5119 10.8234 15.0388 11.1567 15.3157 11.6488H10.8644C10.4288 11.6488 10.0757 12.0019 10.0757 12.4375C10.0757 12.873 10.4288 13.2261 10.8644 13.2261H15.3157C15.0388 13.7182 14.5119 14.0515 13.9083 14.0515H10.8644C10.5497 14.0515 10.2651 14.2386 10.1404 14.5275C10.0156 14.8164 10.0746 15.1519 10.2904 15.3809L14.5795 19.9335C14.7347 20.0982 14.9439 20.1814 15.1537 20.1814C15.3476 20.1814 15.542 20.1102 15.6943 19.9667C16.0114 19.6681 16.0263 19.1689 15.7275 18.8519L12.691 15.6288H13.9083C15.3959 15.6288 16.6488 14.6056 17.0008 13.2261H18.3155C18.7511 13.2261 19.1042 12.873 19.1042 12.4375C19.1042 12.0019 18.751 11.6488 18.3154 11.6488Z"
        fill="#FFEA94"
      />
    </g>
    <defs>
      <clipPath id="clip0_220_63">
        <rect
          width="19.3222"
          height="19.3222"
          fill="white"
          transform="translate(4.68591 4.28662)"
        />
      </clipPath>
    </defs>
  </svg>
  
);

export const CopyNoteIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
    <g clipPath="url(#clip0_14_1091)">
    <path d="M20.0684 0.596191V5.0502H24.522L20.0684 0.596191Z" fill="#003C8E"/>
    <path d="M19.3359 6.51514C18.9314 6.51514 18.6035 6.18721 18.6035 5.78271V0.16748H8.10547C6.8939 0.16748 5.9082 1.15317 5.9082 2.36475V10.5527C6.14951 10.5308 6.3937 10.519 6.64062 10.519C9.13711 10.519 11.3719 11.6604 12.8509 13.4487H20.8008C21.2053 13.4487 21.5332 13.7767 21.5332 14.1812C21.5332 14.5856 21.2053 14.9136 20.8008 14.9136H13.8158C14.2736 15.8069 14.5688 16.7966 14.6636 17.8433H20.8008C21.2053 17.8433 21.5332 18.1712 21.5332 18.5757C21.5332 18.9802 21.2053 19.3081 20.8008 19.3081H14.6636C14.4446 21.727 13.1522 23.8406 11.2675 25.1675H22.7539C23.9655 25.1675 24.9512 24.1818 24.9512 22.9702V6.51514H19.3359ZM20.8008 10.519H10.0586C9.6541 10.519 9.32617 10.1911 9.32617 9.78662C9.32617 9.38213 9.6541 9.0542 10.0586 9.0542H20.8008C21.2053 9.0542 21.5332 9.38213 21.5332 9.78662C21.5332 10.1911 21.2053 10.519 20.8008 10.519Z" fill="#003C8E"/>
    <path d="M6.64062 11.9839C3.00591 11.9839 0.0488281 14.941 0.0488281 18.5757C0.0488281 22.2104 3.00591 25.1675 6.64062 25.1675C10.2753 25.1675 13.2324 22.2104 13.2324 18.5757C13.2324 14.941 10.2753 11.9839 6.64062 11.9839ZM8.59375 19.3081H6.64062C6.23613 19.3081 5.9082 18.9802 5.9082 18.5757V15.646C5.9082 15.2415 6.23613 14.9136 6.64062 14.9136C7.04512 14.9136 7.37305 15.2415 7.37305 15.646V17.8433H8.59375C8.99824 17.8433 9.32617 18.1712 9.32617 18.5757C9.32617 18.9802 8.99824 19.3081 8.59375 19.3081Z" fill="#003C8E"/>
    </g>
    <defs>
    <clipPath id="clip0_14_1091">
    <rect width="25" height="25" fill="white" transform="translate(0 0.16748)"/>
    </clipPath>
    </defs>
    </svg>
  
);
export const RupeeIconTo = (props) => (
    <svg
  width={28}
  height={28}
  viewBox="0 0 28 28"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g filter="url(#filter0_ii_83_102)">
    <rect
      x="1.28223"
      y="1.12646"
      width="25.716"
      height="25.716"
      rx="12.858"
      fill="#684C00"
    />
  </g>
  <rect
    x="0.782227"
    y="0.626465"
    width="26.716"
    height="26.716"
    rx="13.358"
    stroke="#AD8E08"
  />
  <g clipPath="url(#clip0_83_102)">
    <path
      d="M24.0675 13.8858C24.0675 19.3759 19.6169 23.8265 14.1268 23.8265C11.2326 23.8265 8.62731 22.5898 6.81079 20.6159C6.33364 20.0977 5.91126 19.5285 5.55177 18.9178C4.68388 17.4417 4.18604 15.7218 4.18604 13.8858C4.18604 8.39568 8.63664 3.94507 14.1268 3.94507C15.9632 3.94507 17.6831 4.44292 19.1588 5.31121C19.7695 5.67029 20.3383 6.09267 20.8564 6.57023C22.8304 8.38594 24.0675 10.9916 24.0675 13.8858Z"
      fill="#F0CD00"
    />
    <path
      d="M24.0677 13.8859C24.0677 19.2522 19.8159 23.6253 14.497 23.8197C9.17806 23.6253 4.92627 19.2522 4.92627 13.8859C4.92627 8.51949 9.17806 4.14638 14.497 3.95203C19.8159 4.14638 24.0677 8.51949 24.0677 13.8859Z"
      fill="#FFDE50"
    />
    <path
      d="M20.8564 6.57018L6.81078 20.6158C6.33363 20.0977 5.91125 19.5284 5.55176 18.9178L19.1588 5.31116C19.7694 5.67024 20.3383 6.09262 20.8564 6.57018Z"
      fill="#FFEA94"
    />
    <path
      d="M23.3816 10.2516L10.4919 23.1413C9.57941 22.7826 8.73262 22.2929 7.9751 21.6952L21.9359 7.73438C22.5336 8.4919 23.0233 9.33869 23.3816 10.2516Z"
      fill="#FFEA94"
    />
    <path
      d="M21.8515 13.8858C21.8515 18.1518 18.3929 21.6104 14.1269 21.6104C12.6411 21.6104 11.2534 21.1908 10.0755 20.4637C9.56228 20.1473 9.08918 19.7719 8.66477 19.3475C8.35276 19.0359 8.06711 18.6971 7.8119 18.3356C7.46052 17.8378 7.16636 17.2965 6.93955 16.7216C6.60359 15.8715 6.41452 14.9472 6.40316 13.9808C6.40234 13.9491 6.40234 13.9175 6.40234 13.8858C6.40234 9.61982 9.8605 6.16125 14.1269 6.16125C14.1586 6.16125 14.1906 6.16125 14.2223 6.16207C15.1887 6.17343 16.1126 6.36291 16.9627 6.69846C17.5376 6.92568 18.0789 7.21944 18.5767 7.57081C18.9382 7.82643 19.2766 8.11167 19.5886 8.42368C20.013 8.84769 20.3883 9.32119 20.7048 9.83446C21.4319 11.0123 21.8515 12.4 21.8515 13.8858Z"
      fill="#FAA300"
    />
    <path
      d="M19.5886 8.42368L8.66477 19.3475C8.35276 19.0359 8.06711 18.6971 7.8119 18.3356C7.46052 17.8378 7.16636 17.2965 6.93955 16.7216C6.60359 15.8715 6.41452 14.9472 6.40316 13.9808C6.40234 13.9491 6.40234 13.9175 6.40234 13.8858C6.40234 9.61982 9.8605 6.16125 14.1269 6.16125C14.1586 6.16125 14.1906 6.16125 14.2223 6.16207C15.1887 6.17343 16.1126 6.36291 16.9627 6.69846C17.5376 6.92568 18.0789 7.21944 18.5767 7.57081C18.9382 7.82643 19.2766 8.11167 19.5886 8.42368Z"
      fill="#FFBD00"
    />
    <path
      d="M21.8512 13.8858C21.8512 18.1518 18.3926 21.6104 14.1266 21.6104C13.9801 21.6104 13.8349 21.6063 13.6904 21.5982C17.7536 21.3722 20.9784 18.0053 20.9784 13.8858C20.9784 9.76629 17.7536 6.39943 13.6904 6.17343C13.8349 6.16531 13.9801 6.16125 14.1266 6.16125C18.3926 6.16125 21.8512 9.61982 21.8512 13.8858Z"
      fill="#F68E00"
    />
    <g filter="url(#filter1_d_83_102)">
      <mask id="path-10-inside-1_83_102" fill="white">
        <path d="M14.3539 20.264C21.4574 19.8563 22.7781 9.85214 16.0378 7.60563C14.1726 6.98142 12.0341 7.26534 10.4024 8.36605H10.4028C9.64662 8.86885 9.0042 9.52459 8.51701 10.291C8.02983 11.0573 7.7087 11.9173 7.57436 12.8155L7.57395 12.8152C6.93466 16.8243 10.2986 20.5291 14.3539 20.264ZM19.6113 16.1465C19.3794 16.6955 19.0678 17.2073 18.6864 17.6653C18.6595 17.5047 18.7338 17.3188 18.6231 17.169C18.503 16.9349 18.3918 16.696 18.2666 16.4647C18.2201 16.3787 18.2329 16.3292 18.3015 16.2673C19.0359 15.6229 18.3812 15.9655 18.4534 15.0445C18.456 15.0196 18.451 14.9945 18.4392 14.9725C18.4274 14.9504 18.4092 14.9324 18.387 14.9208C18.0389 14.6986 17.5845 14.6222 17.2247 14.8692C16.7763 15.0811 16.1368 14.919 15.9918 14.4044C15.8635 14.0623 15.8792 13.7169 15.8759 13.3675C15.8965 13.1791 16.155 13.1475 16.1131 12.9298C16.123 12.6533 16.0329 12.3614 16.2944 12.1809C16.3144 12.1632 16.3383 12.1505 16.3641 12.1436C16.3899 12.1368 16.417 12.1361 16.4432 12.1415C16.6821 12.1704 16.9235 12.1141 17.125 11.9825C17.3387 11.847 17.6025 11.9347 17.8392 11.9039C17.952 11.8959 18.0356 11.929 18.1051 12.0168C18.2416 12.1892 18.4553 12.2399 18.6347 12.3446C18.6951 12.3798 18.7275 12.3354 18.7558 12.2989C18.9066 12.1044 19.1377 12.039 19.3403 11.9272C19.4506 11.8639 19.6719 12.1053 19.8602 12.1139C20.2356 13.4277 20.1485 14.8902 19.6113 16.1465ZM19.5231 11.2089C19.2982 11.2385 19.4494 11.0248 19.3333 10.913C19.2168 10.809 19.1059 10.6987 19.0012 10.5828C18.947 10.5249 18.9119 10.5156 18.8492 10.5774C18.6809 10.744 18.6904 10.7263 18.8867 10.9253C19.1159 11.1773 19.2886 11.1731 18.8739 11.3482C18.7795 11.3907 18.6904 11.4875 18.5874 11.3476C18.5251 11.2629 18.4402 11.206 18.4503 11.0756C18.4658 10.8745 18.3123 10.7287 18.2414 10.5551C18.2202 10.5033 18.1827 10.5398 18.1627 10.5653C18.0134 10.7573 17.7878 10.8315 17.5834 10.9382C17.2304 11.2468 17.311 11.2132 16.8426 11.1998C16.7992 11.2017 16.7865 11.1494 16.7676 11.1188C16.5318 10.7327 16.5775 10.6386 16.8219 10.2741C16.9118 10.2201 17.3089 10.2824 17.384 10.3608C17.4177 10.396 17.4454 10.437 17.4941 10.4984C17.5315 10.3489 17.5126 10.2344 17.5164 10.1216C17.5798 9.65862 17.9687 9.86724 18.2449 9.7667C18.3754 9.66694 18.429 9.61727 18.4013 9.56833C18.8629 10.0497 19.2419 10.604 19.5231 11.2089ZM18.3635 9.52958C18.175 9.40687 17.7563 9.27749 17.7452 8.97427C17.9638 9.14495 18.1704 9.33049 18.3635 9.52958ZM9.69502 9.47091C10.0464 9.11905 10.4395 8.81153 10.8656 8.55521C11.0105 8.62918 11.1139 8.90131 11.2956 8.80462C11.4895 8.70289 11.6961 8.62222 11.8352 8.44032C11.9141 8.34455 12.0521 8.41785 12.155 8.3888C12.5599 8.33399 12.6693 8.79495 12.8208 9.06918C12.8074 9.08043 12.8004 9.09122 12.7945 9.09055C12.4433 9.05091 12.1212 9.16371 11.8028 9.28629C11.6982 9.32657 11.6176 9.32999 11.5522 9.22929C11.4713 9.10476 11.3674 9.10116 11.2385 9.15488C11.119 9.23934 10.6897 9.25393 10.7194 9.42342C10.7485 9.58266 10.6228 9.85408 10.9086 9.79983C11.0426 9.75323 11.1577 10.149 11.2396 9.92147C11.4152 9.20982 12.1557 9.83085 12.7266 9.37613C12.9367 9.2515 13.1094 9.66201 13.1911 9.80661C13.2531 9.94229 13.298 10.102 13.5161 10.0547C13.3793 10.1915 13.2416 10.3274 13.1063 10.4657C13.0671 10.5058 13.0315 10.493 12.9874 10.4777C12.8174 10.4187 12.645 10.3662 12.4756 10.3055C12.3947 10.2766 12.356 10.2737 12.3578 10.382C12.4962 11.1268 11.8617 10.4085 11.421 10.9671C10.8712 11.5196 11.2967 11.9834 10.541 12.5643C10.4959 12.6058 10.4583 12.6108 10.4137 12.578C10.0854 12.3449 9.34784 12.2183 9.10262 12.5992C9.0991 12.6107 9.09824 12.6228 9.1001 12.6347C9.10197 12.6466 9.10651 12.6578 9.11338 12.6677C9.24472 12.8782 9.25502 13.2324 9.50438 12.8792C9.5786 12.816 9.66579 12.8373 9.7418 12.8499C9.82176 12.8632 9.78205 12.9479 9.78006 12.9971C9.79136 13.1935 10.0739 13.2285 10.0183 13.4496C9.98659 13.6096 10.1881 13.5212 10.2766 13.548C10.4197 13.5686 10.5283 13.5208 10.6201 13.409C10.6896 13.3242 11.0891 13.2666 11.181 13.3212C11.254 13.3947 11.2846 13.5095 11.3369 13.5992C11.4239 13.7737 11.4276 13.7772 11.5556 13.6393C11.8497 13.4084 12.2631 13.5911 12.5429 13.7514C12.7628 13.8745 12.6902 14.3142 13.0177 14.251C13.0806 14.2362 13.1146 14.2897 13.1491 14.3286C13.3869 14.6196 13.771 14.5848 13.9117 14.9838C14.0024 15.1503 13.9927 15.2962 13.9157 15.4608C13.8609 15.7701 13.7088 15.998 13.3877 16.0847C13.133 16.1761 13.5626 16.5916 12.9797 16.7573C12.8302 16.7899 12.8109 16.9044 12.8302 17.0387C12.8921 17.3845 12.8081 17.6455 12.4277 17.7366C12.3152 17.7737 12.3353 17.9233 12.2819 18.0086C12.0195 18.4868 12.258 18.8357 12.5922 19.1707C12.2989 19.188 11.981 19.2178 11.8796 18.902C11.7529 18.5341 11.6383 18.1631 11.4505 17.8191C11.3874 17.7036 11.428 17.5694 11.4264 17.4442C11.3806 16.9317 10.8572 16.548 10.9555 16.002C10.9936 15.7285 10.6035 16.119 10.1996 15.6213C10.065 15.4616 9.75175 15.0756 9.80585 14.8755C9.91642 14.5999 9.92808 14.2674 10.1834 14.0761C10.2921 13.9916 10.302 13.728 10.0992 13.7791C9.57822 13.8663 9.68953 13.4748 9.38442 13.5491C9.17781 13.5711 9.02867 13.5034 8.8681 13.3589C8.38637 12.9158 8.24828 13.2441 7.97227 12.9156C8.15749 11.6108 8.76218 10.4018 9.69502 9.47091Z" />
      </mask>
      <path
        d="M14.3539 20.264C21.4574 19.8563 22.7781 9.85214 16.0378 7.60563C14.1726 6.98142 12.0341 7.26534 10.4024 8.36605H10.4028C9.64662 8.86885 9.0042 9.52459 8.51701 10.291C8.02983 11.0573 7.7087 11.9173 7.57436 12.8155L7.57395 12.8152C6.93466 16.8243 10.2986 20.5291 14.3539 20.264ZM19.6113 16.1465C19.3794 16.6955 19.0678 17.2073 18.6864 17.6653C18.6595 17.5047 18.7338 17.3188 18.6231 17.169C18.503 16.9349 18.3918 16.696 18.2666 16.4647C18.2201 16.3787 18.2329 16.3292 18.3015 16.2673C19.0359 15.6229 18.3812 15.9655 18.4534 15.0445C18.456 15.0196 18.451 14.9945 18.4392 14.9725C18.4274 14.9504 18.4092 14.9324 18.387 14.9208C18.0389 14.6986 17.5845 14.6222 17.2247 14.8692C16.7763 15.0811 16.1368 14.919 15.9918 14.4044C15.8635 14.0623 15.8792 13.7169 15.8759 13.3675C15.8965 13.1791 16.155 13.1475 16.1131 12.9298C16.123 12.6533 16.0329 12.3614 16.2944 12.1809C16.3144 12.1632 16.3383 12.1505 16.3641 12.1436C16.3899 12.1368 16.417 12.1361 16.4432 12.1415C16.6821 12.1704 16.9235 12.1141 17.125 11.9825C17.3387 11.847 17.6025 11.9347 17.8392 11.9039C17.952 11.8959 18.0356 11.929 18.1051 12.0168C18.2416 12.1892 18.4553 12.2399 18.6347 12.3446C18.6951 12.3798 18.7275 12.3354 18.7558 12.2989C18.9066 12.1044 19.1377 12.039 19.3403 11.9272C19.4506 11.8639 19.6719 12.1053 19.8602 12.1139C20.2356 13.4277 20.1485 14.8902 19.6113 16.1465ZM19.5231 11.2089C19.2982 11.2385 19.4494 11.0248 19.3333 10.913C19.2168 10.809 19.1059 10.6987 19.0012 10.5828C18.947 10.5249 18.9119 10.5156 18.8492 10.5774C18.6809 10.744 18.6904 10.7263 18.8867 10.9253C19.1159 11.1773 19.2886 11.1731 18.8739 11.3482C18.7795 11.3907 18.6904 11.4875 18.5874 11.3476C18.5251 11.2629 18.4402 11.206 18.4503 11.0756C18.4658 10.8745 18.3123 10.7287 18.2414 10.5551C18.2202 10.5033 18.1827 10.5398 18.1627 10.5653C18.0134 10.7573 17.7878 10.8315 17.5834 10.9382C17.2304 11.2468 17.311 11.2132 16.8426 11.1998C16.7992 11.2017 16.7865 11.1494 16.7676 11.1188C16.5318 10.7327 16.5775 10.6386 16.8219 10.2741C16.9118 10.2201 17.3089 10.2824 17.384 10.3608C17.4177 10.396 17.4454 10.437 17.4941 10.4984C17.5315 10.3489 17.5126 10.2344 17.5164 10.1216C17.5798 9.65862 17.9687 9.86724 18.2449 9.7667C18.3754 9.66694 18.429 9.61727 18.4013 9.56833C18.8629 10.0497 19.2419 10.604 19.5231 11.2089ZM18.3635 9.52958C18.175 9.40687 17.7563 9.27749 17.7452 8.97427C17.9638 9.14495 18.1704 9.33049 18.3635 9.52958ZM9.69502 9.47091C10.0464 9.11905 10.4395 8.81153 10.8656 8.55521C11.0105 8.62918 11.1139 8.90131 11.2956 8.80462C11.4895 8.70289 11.6961 8.62222 11.8352 8.44032C11.9141 8.34455 12.0521 8.41785 12.155 8.3888C12.5599 8.33399 12.6693 8.79495 12.8208 9.06918C12.8074 9.08043 12.8004 9.09122 12.7945 9.09055C12.4433 9.05091 12.1212 9.16371 11.8028 9.28629C11.6982 9.32657 11.6176 9.32999 11.5522 9.22929C11.4713 9.10476 11.3674 9.10116 11.2385 9.15488C11.119 9.23934 10.6897 9.25393 10.7194 9.42342C10.7485 9.58266 10.6228 9.85408 10.9086 9.79983C11.0426 9.75323 11.1577 10.149 11.2396 9.92147C11.4152 9.20982 12.1557 9.83085 12.7266 9.37613C12.9367 9.2515 13.1094 9.66201 13.1911 9.80661C13.2531 9.94229 13.298 10.102 13.5161 10.0547C13.3793 10.1915 13.2416 10.3274 13.1063 10.4657C13.0671 10.5058 13.0315 10.493 12.9874 10.4777C12.8174 10.4187 12.645 10.3662 12.4756 10.3055C12.3947 10.2766 12.356 10.2737 12.3578 10.382C12.4962 11.1268 11.8617 10.4085 11.421 10.9671C10.8712 11.5196 11.2967 11.9834 10.541 12.5643C10.4959 12.6058 10.4583 12.6108 10.4137 12.578C10.0854 12.3449 9.34784 12.2183 9.10262 12.5992C9.0991 12.6107 9.09824 12.6228 9.1001 12.6347C9.10197 12.6466 9.10651 12.6578 9.11338 12.6677C9.24472 12.8782 9.25502 13.2324 9.50438 12.8792C9.5786 12.816 9.66579 12.8373 9.7418 12.8499C9.82176 12.8632 9.78205 12.9479 9.78006 12.9971C9.79136 13.1935 10.0739 13.2285 10.0183 13.4496C9.98659 13.6096 10.1881 13.5212 10.2766 13.548C10.4197 13.5686 10.5283 13.5208 10.6201 13.409C10.6896 13.3242 11.0891 13.2666 11.181 13.3212C11.254 13.3947 11.2846 13.5095 11.3369 13.5992C11.4239 13.7737 11.4276 13.7772 11.5556 13.6393C11.8497 13.4084 12.2631 13.5911 12.5429 13.7514C12.7628 13.8745 12.6902 14.3142 13.0177 14.251C13.0806 14.2362 13.1146 14.2897 13.1491 14.3286C13.3869 14.6196 13.771 14.5848 13.9117 14.9838C14.0024 15.1503 13.9927 15.2962 13.9157 15.4608C13.8609 15.7701 13.7088 15.998 13.3877 16.0847C13.133 16.1761 13.5626 16.5916 12.9797 16.7573C12.8302 16.7899 12.8109 16.9044 12.8302 17.0387C12.8921 17.3845 12.8081 17.6455 12.4277 17.7366C12.3152 17.7737 12.3353 17.9233 12.2819 18.0086C12.0195 18.4868 12.258 18.8357 12.5922 19.1707C12.2989 19.188 11.981 19.2178 11.8796 18.902C11.7529 18.5341 11.6383 18.1631 11.4505 17.8191C11.3874 17.7036 11.428 17.5694 11.4264 17.4442C11.3806 16.9317 10.8572 16.548 10.9555 16.002C10.9936 15.7285 10.6035 16.119 10.1996 15.6213C10.065 15.4616 9.75175 15.0756 9.80585 14.8755C9.91642 14.5999 9.92808 14.2674 10.1834 14.0761C10.2921 13.9916 10.302 13.728 10.0992 13.7791C9.57822 13.8663 9.68953 13.4748 9.38442 13.5491C9.17781 13.5711 9.02867 13.5034 8.8681 13.3589C8.38637 12.9158 8.24828 13.2441 7.97227 12.9156C8.15749 11.6108 8.76218 10.4018 9.69502 9.47091Z"
        fill="#915300"
      />
      <path
        d="M14.3539 20.264C21.4574 19.8563 22.7781 9.85214 16.0378 7.60563C14.1726 6.98142 12.0341 7.26534 10.4024 8.36605H10.4028C9.64662 8.86885 9.0042 9.52459 8.51701 10.291C8.02983 11.0573 7.7087 11.9173 7.57436 12.8155L7.57395 12.8152C6.93466 16.8243 10.2986 20.5291 14.3539 20.264ZM19.6113 16.1465C19.3794 16.6955 19.0678 17.2073 18.6864 17.6653C18.6595 17.5047 18.7338 17.3188 18.6231 17.169C18.503 16.9349 18.3918 16.696 18.2666 16.4647C18.2201 16.3787 18.2329 16.3292 18.3015 16.2673C19.0359 15.6229 18.3812 15.9655 18.4534 15.0445C18.456 15.0196 18.451 14.9945 18.4392 14.9725C18.4274 14.9504 18.4092 14.9324 18.387 14.9208C18.0389 14.6986 17.5845 14.6222 17.2247 14.8692C16.7763 15.0811 16.1368 14.919 15.9918 14.4044C15.8635 14.0623 15.8792 13.7169 15.8759 13.3675C15.8965 13.1791 16.155 13.1475 16.1131 12.9298C16.123 12.6533 16.0329 12.3614 16.2944 12.1809C16.3144 12.1632 16.3383 12.1505 16.3641 12.1436C16.3899 12.1368 16.417 12.1361 16.4432 12.1415C16.6821 12.1704 16.9235 12.1141 17.125 11.9825C17.3387 11.847 17.6025 11.9347 17.8392 11.9039C17.952 11.8959 18.0356 11.929 18.1051 12.0168C18.2416 12.1892 18.4553 12.2399 18.6347 12.3446C18.6951 12.3798 18.7275 12.3354 18.7558 12.2989C18.9066 12.1044 19.1377 12.039 19.3403 11.9272C19.4506 11.8639 19.6719 12.1053 19.8602 12.1139C20.2356 13.4277 20.1485 14.8902 19.6113 16.1465ZM19.5231 11.2089C19.2982 11.2385 19.4494 11.0248 19.3333 10.913C19.2168 10.809 19.1059 10.6987 19.0012 10.5828C18.947 10.5249 18.9119 10.5156 18.8492 10.5774C18.6809 10.744 18.6904 10.7263 18.8867 10.9253C19.1159 11.1773 19.2886 11.1731 18.8739 11.3482C18.7795 11.3907 18.6904 11.4875 18.5874 11.3476C18.5251 11.2629 18.4402 11.206 18.4503 11.0756C18.4658 10.8745 18.3123 10.7287 18.2414 10.5551C18.2202 10.5033 18.1827 10.5398 18.1627 10.5653C18.0134 10.7573 17.7878 10.8315 17.5834 10.9382C17.2304 11.2468 17.311 11.2132 16.8426 11.1998C16.7992 11.2017 16.7865 11.1494 16.7676 11.1188C16.5318 10.7327 16.5775 10.6386 16.8219 10.2741C16.9118 10.2201 17.3089 10.2824 17.384 10.3608C17.4177 10.396 17.4454 10.437 17.4941 10.4984C17.5315 10.3489 17.5126 10.2344 17.5164 10.1216C17.5798 9.65862 17.9687 9.86724 18.2449 9.7667C18.3754 9.66694 18.429 9.61727 18.4013 9.56833C18.8629 10.0497 19.2419 10.604 19.5231 11.2089ZM18.3635 9.52958C18.175 9.40687 17.7563 9.27749 17.7452 8.97427C17.9638 9.14495 18.1704 9.33049 18.3635 9.52958ZM9.69502 9.47091C10.0464 9.11905 10.4395 8.81153 10.8656 8.55521C11.0105 8.62918 11.1139 8.90131 11.2956 8.80462C11.4895 8.70289 11.6961 8.62222 11.8352 8.44032C11.9141 8.34455 12.0521 8.41785 12.155 8.3888C12.5599 8.33399 12.6693 8.79495 12.8208 9.06918C12.8074 9.08043 12.8004 9.09122 12.7945 9.09055C12.4433 9.05091 12.1212 9.16371 11.8028 9.28629C11.6982 9.32657 11.6176 9.32999 11.5522 9.22929C11.4713 9.10476 11.3674 9.10116 11.2385 9.15488C11.119 9.23934 10.6897 9.25393 10.7194 9.42342C10.7485 9.58266 10.6228 9.85408 10.9086 9.79983C11.0426 9.75323 11.1577 10.149 11.2396 9.92147C11.4152 9.20982 12.1557 9.83085 12.7266 9.37613C12.9367 9.2515 13.1094 9.66201 13.1911 9.80661C13.2531 9.94229 13.298 10.102 13.5161 10.0547C13.3793 10.1915 13.2416 10.3274 13.1063 10.4657C13.0671 10.5058 13.0315 10.493 12.9874 10.4777C12.8174 10.4187 12.645 10.3662 12.4756 10.3055C12.3947 10.2766 12.356 10.2737 12.3578 10.382C12.4962 11.1268 11.8617 10.4085 11.421 10.9671C10.8712 11.5196 11.2967 11.9834 10.541 12.5643C10.4959 12.6058 10.4583 12.6108 10.4137 12.578C10.0854 12.3449 9.34784 12.2183 9.10262 12.5992C9.0991 12.6107 9.09824 12.6228 9.1001 12.6347C9.10197 12.6466 9.10651 12.6578 9.11338 12.6677C9.24472 12.8782 9.25502 13.2324 9.50438 12.8792C9.5786 12.816 9.66579 12.8373 9.7418 12.8499C9.82176 12.8632 9.78205 12.9479 9.78006 12.9971C9.79136 13.1935 10.0739 13.2285 10.0183 13.4496C9.98659 13.6096 10.1881 13.5212 10.2766 13.548C10.4197 13.5686 10.5283 13.5208 10.6201 13.409C10.6896 13.3242 11.0891 13.2666 11.181 13.3212C11.254 13.3947 11.2846 13.5095 11.3369 13.5992C11.4239 13.7737 11.4276 13.7772 11.5556 13.6393C11.8497 13.4084 12.2631 13.5911 12.5429 13.7514C12.7628 13.8745 12.6902 14.3142 13.0177 14.251C13.0806 14.2362 13.1146 14.2897 13.1491 14.3286C13.3869 14.6196 13.771 14.5848 13.9117 14.9838C14.0024 15.1503 13.9927 15.2962 13.9157 15.4608C13.8609 15.7701 13.7088 15.998 13.3877 16.0847C13.133 16.1761 13.5626 16.5916 12.9797 16.7573C12.8302 16.7899 12.8109 16.9044 12.8302 17.0387C12.8921 17.3845 12.8081 17.6455 12.4277 17.7366C12.3152 17.7737 12.3353 17.9233 12.2819 18.0086C12.0195 18.4868 12.258 18.8357 12.5922 19.1707C12.2989 19.188 11.981 19.2178 11.8796 18.902C11.7529 18.5341 11.6383 18.1631 11.4505 17.8191C11.3874 17.7036 11.428 17.5694 11.4264 17.4442C11.3806 16.9317 10.8572 16.548 10.9555 16.002C10.9936 15.7285 10.6035 16.119 10.1996 15.6213C10.065 15.4616 9.75175 15.0756 9.80585 14.8755C9.91642 14.5999 9.92808 14.2674 10.1834 14.0761C10.2921 13.9916 10.302 13.728 10.0992 13.7791C9.57822 13.8663 9.68953 13.4748 9.38442 13.5491C9.17781 13.5711 9.02867 13.5034 8.8681 13.3589C8.38637 12.9158 8.24828 13.2441 7.97227 12.9156C8.15749 11.6108 8.76218 10.4018 9.69502 9.47091Z"
        stroke="#FFE72F"
        strokeWidth="0.2"
        mask="url(#path-10-inside-1_83_102)"
      />
    </g>
  </g>
  <defs>
    <filter
      id="filter0_ii_83_102"
      x="0.282227"
      y="-0.873535"
      width="27.7158"
      height="29.7161"
      filterUnits="userSpaceOnUse"
      colorInterpolationFilters="sRGB"
    >
      <feFlood floodOpacity={0} result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy={1} />
      <feGaussianBlur stdDeviation="0.55" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.966667 0 0 0 0 0.861978 0 0 0 0 0.61625 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_83_102" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy={-1} />
      <feGaussianBlur stdDeviation={1} />
      <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 1 0 0 0 0 0.792781 0 0 0 0 0.483333 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="effect1_innerShadow_83_102"
        result="effect2_innerShadow_83_102"
      />
    </filter>
    <filter
      id="filter1_d_83_102"
      x="7.49561"
      y="7.28003"
      width="12.9526"
      height="13.4974"
      filterUnits="userSpaceOnUse"
      colorInterpolationFilters="sRGB"
    >
      <feFlood floodOpacity={0} result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="0.5" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_83_102"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_83_102"
        result="shape"
      />
    </filter>
    <clipPath id="clip0_83_102">
      <rect
        width="19.8815"
        height="19.8815"
        fill="white"
        transform="translate(4.18604 3.94507)"
      />
    </clipPath>
  </defs>
</svg>
);
export const DownloadIcon = (props) => (
    <svg
    width={20}
    height={20}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 2a1 1 0 0 1 1 1v10.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L11 13.586V3a1 1 0 0 1 1-1M5 17a1 1 0 0 1 1 1v2h12v-2a1 1 0 1 1 2 0v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2a1 1 0 0 1 1-1"
      fill="#ffb600"
    />
  </svg>
);

export const Description = (props) => (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={27}
    height={27}
    viewBox="0 0 27 27"
    fill="none"
  >
    <g clipPath="url(#clip0_450_9)">
      <path
        d="M4.26986 17.2871L1.81094 22.2042C1.69272 22.4404 1.70541 22.7211 1.84407 22.9456C1.98312 23.17 2.2279 23.3067 2.49193 23.3067H6.19082L8.41012 26.2657C8.55433 26.4587 8.78067 26.5704 9.0189 26.5704C9.33529 26.5704 9.58464 26.3815 9.70048 26.1494L12.0176 21.515C8.88481 21.2155 6.12278 19.627 4.26986 17.2871Z"
        fill="#323288"
      />
      <path
        d="M24.3864 22.2042L21.9275 17.2871C20.0745 19.627 17.3125 21.2155 14.1797 21.515L16.497 26.1494C16.6127 26.3815 16.862 26.5704 17.1784 26.5704C17.4167 26.5704 17.6432 26.4587 17.7874 26.2657L20.0065 23.3067H23.7054C23.9694 23.3067 24.2142 23.17 24.3533 22.9456C24.4919 22.7211 24.5046 22.4404 24.3864 22.2042Z"
        fill="#323288"
      />
      <path
        d="M14.3735 8.06786L13.0986 6.03125L11.8242 8.06786C11.7196 8.23488 11.5544 8.35489 11.3634 8.40269L9.03278 8.98569L10.5757 10.8273C10.7022 10.9783 10.7653 11.1725 10.7516 11.369L10.5856 13.7657L12.8138 12.8675C12.9197 12.8248 13.1363 12.7679 13.3833 12.8675L15.6117 13.7657L15.4459 11.369C15.4324 11.1725 15.4955 10.9783 15.622 10.8273L17.1649 8.98569L14.8343 8.40269C14.6433 8.35489 14.4781 8.23488 14.3735 8.06786Z"
        fill="#323288"
      />
      <path
        d="M22.8351 10.3068C22.8351 4.9381 18.4674 0.570312 13.0986 0.570312C7.7299 0.570312 3.36212 4.9381 3.36212 10.3068C3.36212 15.6754 7.7299 20.0433 13.0986 20.0433C18.4674 20.0433 22.8351 15.6756 22.8351 10.3068ZM19.1142 9.03114L16.987 11.5702L17.2155 14.8746C17.2335 15.1364 17.1157 15.3891 16.9035 15.5434C16.691 15.6976 16.4143 15.7317 16.1709 15.6337L13.0986 14.3953L10.0264 15.6337C9.94405 15.6668 9.61615 15.7775 9.29381 15.5434C9.08156 15.3891 8.96373 15.1364 8.98178 14.8746L9.21069 11.5702L7.08344 9.03134C6.91483 8.83 6.86166 8.55626 6.94279 8.30672C7.02393 8.05717 7.22784 7.86674 7.48254 7.80307L10.6956 6.9993L12.453 4.19145C12.5922 3.96909 12.8362 3.834 13.0986 3.834C13.3611 3.834 13.6051 3.96909 13.7443 4.19145L15.502 6.9993L18.7151 7.80307C18.9698 7.86674 19.1737 8.05717 19.2549 8.30672C19.336 8.55626 19.2828 8.83 19.1142 9.03114Z"
        fill="#323288"
      />
      <path
        d="M13.1055 9.05778C12.9939 9.05778 12.887 9.10208 12.8082 9.18093C12.7293 9.25978 12.685 9.36672 12.685 9.47823V12.0009C12.685 12.1124 12.7293 12.2194 12.8082 12.2982C12.887 12.3771 12.9939 12.4214 13.1055 12.4214C13.217 12.4214 13.3239 12.3771 13.4028 12.2982C13.4816 12.2194 13.5259 12.1124 13.5259 12.0009V9.47823C13.5259 9.36672 13.4816 9.25978 13.4028 9.18093C13.3239 9.10208 13.217 9.05778 13.1055 9.05778ZM13.1055 7.37598C13.0015 7.37598 12.8999 7.4068 12.8135 7.46455C12.727 7.5223 12.6597 7.60438 12.6199 7.70042C12.5801 7.79645 12.5697 7.90212 12.59 8.00407C12.6103 8.10602 12.6603 8.19967 12.7338 8.27317C12.8073 8.34667 12.901 8.39673 13.0029 8.41701C13.1049 8.43728 13.2105 8.42688 13.3066 8.3871C13.4026 8.34732 13.4847 8.27996 13.5424 8.19353C13.6002 8.1071 13.631 8.00549 13.631 7.90154C13.631 7.76215 13.5757 7.62847 13.4771 7.52991C13.3785 7.43135 13.2448 7.37598 13.1055 7.37598Z"
        fill="#F8D03D"
      />
    </g>
    <defs>
      <clipPath id="clip0_450_9">
        <rect
          width={26}
          height={26}
          fill="white"
          transform="translate(0.105408 0.570312)"
        />
      </clipPath>
    </defs>
  </svg>
);


const SVGComponent = (props) => (
  <svg
    width={80}
    height={80}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 2a1 1 0 0 1 1 1v10.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L11 13.586V3a1 1 0 0 1 1-1M5 17a1 1 0 0 1 1 1v2h12v-2a1 1 0 1 1 2 0v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2a1 1 0 0 1 1-1"
      fill="#0D0D0D"
    />
  </svg>
  
);
